import { createContext } from "react";

export const QuejaReclamoContext = createContext<any>("");
